import axios from '@/plugins/axios'
import i18n from '@/plugins/i18n'
import Model from './BaseModel'
import User from './User'

export default class ResellerUser extends Model {
    resourceName() {
        return 'reseller-users'
    }

    fields() {
        return ['email']
    }

    relationships() {
        return {
            user: new User(),
        }
    }

    computed() {
        return {
            name(resellerUser) {
                return resellerUser.user.name
            },
        }
    }

    async resetPassword() {
        return await axios.put(`${this.getSelfUrl()}/reset-password`)
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.resellerUser.attributes.name'),
                value: 'name',
                sortable: false,
            },
            {
                text: i18n.t('resources.resellerUser.attributes.email'),
                value: 'email',
                sortable: false,
            },
            {
                text: 'Ações',
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                label: i18n.t('actions.resellerUser.resetPassword.label'),
                type: 'resetPassword',
                icon: 'mdi-lock-reset',
            },
        ]
    }
}
